/** Why a bank read (connections, accounts, a bank profile, the import history) has nothing to show, in words, or null when it answered or is loading. */
export function bankUnreadyMessage(subject: string, read: { status: string }): string | null {
  if (read.status === 'failed') return `Couldn't load ${subject}. Refresh to try again.`;
  if (read.status === 'offline') return `You're offline, so ${subject} can't load.`;
  return null;
}
